import OrtivisAvatarPreview from "components/onboarding/ortivis/OrtivisAvatarPreview";
import React from "react";

const Player = React.forwardRef(({ player, isCurrent }, ref) => {
	return (
		<div
			ref={ref} // ✅ Accept and apply ref
			className={`absolute bottom-[20px] w-12 h-12 flex flex-col items-center justify-center text-sm
				${isCurrent ? "z-50" : ""}`}
		>
			<OrtivisAvatarPreview avatar={player.avatar} />
			{player.pseudo}
		</div>
	);
});

export default Player;
